(() => {
  const selector = '[data-kuleana-mobile-carousel]';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let carouselCount = 0;

  function buildArrow(direction, label, controls) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `kuleana-mobile-carousel-nav__button kuleana-mobile-carousel-nav__button--${direction}`;
    button.setAttribute('aria-label', `${direction === 'previous' ? 'Previous' : 'Next'} ${label}`);
    button.setAttribute('aria-controls', controls);

    const points = direction === 'previous' ? '14 18 8 12 14 6' : '10 6 16 12 10 18';
    button.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <polyline points="${points}"></polyline>
      </svg>
    `;

    return button;
  }

  function initializeCarousel(carousel) {
    if (!(carousel instanceof HTMLElement) || carousel.dataset.kuleanaCarouselReady === 'true') return;

    carousel.dataset.kuleanaCarouselReady = 'true';
    carouselCount += 1;
    if (!carousel.id) carousel.id = `kuleana-mobile-carousel-${carouselCount}`;

    const label = carousel.dataset.carouselLabel || 'item';
    const navigation = document.createElement('div');
    navigation.className = 'kuleana-mobile-carousel-nav';
    navigation.setAttribute('aria-label', `${label.charAt(0).toUpperCase()}${label.slice(1)} carousel controls`);

    const previous = buildArrow('previous', label, carousel.id);
    const next = buildArrow('next', label, carousel.id);
    navigation.append(previous, next);
    carousel.insertAdjacentElement('afterend', navigation);

    const getItems = () => Array.from(carousel.children).filter((item) => item instanceof HTMLElement && item.offsetWidth > 0);

    const getPositions = () => {
      const carouselRect = carousel.getBoundingClientRect();
      const positions = getItems().map(
        (item) => item.getBoundingClientRect().left - carouselRect.left + carousel.scrollLeft
      );
      const firstPosition = positions[0] || 0;
      return positions.map((position) => Math.max(0, position - firstPosition));
    };

    const updateControls = () => {
      const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      const hasOverflow = mobileQuery.matches && maxScroll > 4;

      navigation.hidden = !hasOverflow;
      previous.disabled = !hasOverflow || carousel.scrollLeft <= 4;
      next.disabled = !hasOverflow || carousel.scrollLeft >= maxScroll - 4;
    };

    const move = (direction) => {
      const positions = getPositions();
      if (positions.length < 2) return;

      const current = carousel.scrollLeft;
      let target;
      if (direction === 'next') {
        target = positions.find((position) => position > current + 8);
        if (target === undefined) target = positions[positions.length - 1];
      } else {
        target = positions.filter((position) => position < current - 8).pop();
        if (target === undefined) target = positions[0];
      }

      carousel.scrollTo({ left: target, behavior: reduceMotionQuery.matches ? 'auto' : 'smooth' });
    };

    previous.addEventListener('click', () => move('previous'));
    next.addEventListener('click', () => move('next'));

    let frame;
    carousel.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(updateControls);
    }, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateControls);
      resizeObserver.observe(carousel);
    } else {
      window.addEventListener('resize', updateControls, { passive: true });
    }

    if (typeof mobileQuery.addEventListener === 'function') mobileQuery.addEventListener('change', updateControls);
    updateControls();
  }

  function initializeWithin(root = document) {
    if (root instanceof Element && root.matches(selector)) initializeCarousel(root);
    root.querySelectorAll?.(selector).forEach(initializeCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin());
  } else {
    initializeWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();